import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=6cecd1f3&scoped=true&functional=true&"
var script = {}
import style0 from "./Head.vue?vue&type=style&index=0&id=6cecd1f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6cecd1f3",
  null
  
)

export default component.exports